import { IconCheck, IconX } from "@tabler/icons-react";

export default function PlansPage() {
    return (
        <>
            <section className="section section-light pt-0">
                <header className="hero">
                    <div className="container">
                        <h2 className="hero-title">Precificação simples e transparente</h2>
                        <p className="hero-description">
                            Tenha acesso completo ao LineXS ERP, com atualizações contínuas e
                            suporte dedicado. Escolha o plano que melhor se adapta à sua empresa.
                        </p>
                    </div>
                </header>
                <section className="section pt-0">
                    <div className="container">
                        <div className="pricing">
                            {/* Plano Essencial */}
                            <div className="pricing-card">
                                <h4 className="pricing-title">Essencial</h4>
                                <div className="pricing-price">
                                    <span className="pricing-price-currency">R$</span> 59
                                    <div className="pricing-price-description ms-0">,00</div>
                                </div>
                                <div className="fs-4 text-secondary">
                                    Microempreendedores e negócios iniciantes.
                                </div>
                                <ul className="pricing-features my-5">
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        01 Usuário
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Gestão de Clientes
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Cadastro de Produtos e Serviços
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Emissão de Orçamentos e Faturas
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Relatórios Financeiros Básicos
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-danger icon-3"
                                        >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M18 6l-12 12" />
                                            <path d="M6 6l12 12" />
                                        </svg>
                                        Gestão de Contratos
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-danger icon-3"
                                        >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M18 6l-12 12" />
                                            <path d="M6 6l12 12" />
                                        </svg>
                                        Integração Bancária
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-danger icon-3"
                                        >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M18 6l-12 12" />
                                            <path d="M6 6l12 12" />
                                        </svg>
                                        Importação de Nota Fiscal XML
                                    </li>
                                </ul>
                                <div className="pricing-btn">
                                    <a href="#" className="btn w-100">
                                        Contratar
                                    </a>
                                </div>
                            </div>
                            {/* Plano Profissional */}
                            <div className="pricing-card featured">
                                <div className="pricing-label">
                                    <div className="badge bg-primary text-primary-fg">Recomendado</div>
                                </div>
                                <h4 className="pricing-title">Profissional</h4>
                                <div className="pricing-price">
                                    <span className="pricing-price-currency">R$</span>129
                                    <div className="pricing-price-description ms-0">,00</div>
                                </div>
                                <div className="fs-4 text-secondary">
                                    Pequenas empresas em expansão.
                                </div>
                                <ul className="pricing-features my-5">
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        03 Usuários
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Gestão de Clientes
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Cadastro de Produtos e Serviços
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Emissão de Orçamentos e Faturas
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Relatórios Financeiros Básicos
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Gestão de Contratos
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Integração Bancária
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-danger icon-3"
                                        >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M18 6l-12 12" />
                                            <path d="M6 6l12 12" />
                                        </svg>
                                        Importação de Nota Fiscal XML
                                    </li>
                                </ul>
                                <div className="pricing-btn">
                                    <a href="#" className="btn w-100 btn-primary">
                                        Contratar
                                    </a>
                                </div>
                            </div>
                            {/* Plano Premium */}
                            <div className="pricing-card">
                                <h4 className="pricing-title">Premium</h4>
                                <div className="pricing-price">
                                    <span className="pricing-price-currency">R$</span>299
                                    <div className="pricing-price-description ms-0">,00</div>
                                </div>
                                <div className="fs-4 text-secondary">
                                    Empresas de porte médio que precisam de mais recursos.
                                </div>
                                <ul className="pricing-features my-5">
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        10 Usuários
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Gestão de Clientes
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Cadastro de Produtos e Serviços
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Emissão de Orçamentos e Faturas
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Relatórios Financeiros Básicos
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Gestão de Contratos
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Integração Bancária
                                    </li>
                                    <li>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-inline me-1 text-green icon-3"
                                        >
                                            <path d="M5 12l5 5l10 -10" />
                                        </svg>
                                        Importação de Nota Fiscal XML
                                    </li>
                                </ul>
                                <div className="pricing-btn">
                                    <a href="#" className="btn w-100">
                                        Contratar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>


            <section className="section section-light pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="card">
                                <div className="table-responsive">
                                    <table className="table table-vcenter table-bordered table-nowrap card-table table-hover">
                                        <thead>
                                            <tr>
                                                <td className="w-50">
                                                    <h3>Soluções acessíveis e completas para sua empresa.</h3>
                                                    <div className="text-secondary text-wrap">
                                                        Invista em um ERP que ajuda você a vender mais, fidelizar
                                                        clientes e simplificar sua rotina.
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="text-uppercase text-secondary font-weight-medium">
                                                        Essencial
                                                    </div>
                                                    <div className="display-6 fw-bold my-3">
                                                        R$ 59<small>,00</small>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="text-uppercase text-secondary font-weight-medium">
                                                        Profissional
                                                    </div>
                                                    <div className="display-6 fw-bold my-3">
                                                        R$ 129<small>,00</small>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="text-uppercase text-secondary font-weight-medium">
                                                        Premium
                                                    </div>
                                                    <div className="display-6 fw-bold my-3">
                                                        R$ 299<small>,00</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Nº de Usuários</td>
                                                <td className="text-center">01</td>
                                                <td className="text-center">03</td>
                                                <td className="text-center">10</td>
                                            </tr>
                                            <tr>
                                                <td>Armazenamento</td>
                                                <td className="text-center">1 GB</td>
                                                <td className="text-center">3 GB</td>
                                                <td className="text-center">5 GB</td>
                                            </tr>
                                            <tr className="bg-surface-tertiary">
                                                <th colSpan={5} className="subheader">
                                                    Cadastros
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Clientes</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Fornecedores</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Produtos</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Serviços</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Segmentos</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Marcas</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Categorias</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Gestão de Estoque</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr className="bg-surface-tertiary">
                                                <th colSpan={5} className="subheader">
                                                    Financeiro
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Orçamentos</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Faturas</td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Contas Bancárias</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Contas a Pagar e Receber</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Relatórios</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Integração Bancária</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr className="bg-surface-tertiary">
                                                <th colSpan={5} className="subheader">
                                                    Pedidos de Compras
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Gerenciar Pedidos</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Importar Notas Fiscais XML</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr className="bg-surface-tertiary">
                                                <th colSpan={5} className="subheader">
                                                    Contratos
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Gestão de Contratos</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Workflows</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            {/* 
                                                    <tr className="bg-surface-tertiary">
                                                        <th colSpan={5} className="subheader">
                                                            Inteligência Artificial
                                                            <small>
                                                                <em>Beta</em>
                                                            </small>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td>Sugestões de Descrições</td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                        <td className="text-center">
                                                            <IconCheck className="icon text-green" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Sugestões de Preços de Venda</td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                        <td className="text-center">
                                                            <IconCheck className="icon text-green" />
                                                        </td>
                                                    </tr> 
                                            */}
                                            <tr className="bg-surface-tertiary">
                                                <th colSpan={5} className="subheader">
                                                    Outros
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Permissões</td>
                                                <td className="text-center">
                                                    <IconX className="icon text-danger" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                                <td className="text-center">
                                                    <IconCheck className="icon text-green" />
                                                </td>
                                            </tr>
                                            
                                            {/*
                                                    <tr>
                                                        <td>
                                                            API de Integração
                                                            <small className="text-uppercase fs-6">
                                                                <em>Beta</em>
                                                            </small>
                                                        </td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                        <td className="text-center">
                                                            <IconX className="icon text-danger" />
                                                        </td>
                                                    </tr>
                                             */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}